<template>





  <v-dialog scrollable="" v-model="val.dialogShow" max-width="600px">
    <v-card color="grey lighten-5">
      <v-toolbar size="120px" color="info">
        <v-toolbar-title class="white--text">  {{ $t('Search-Person') }} </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field solo hide-details v-model="prm.adSoyad" :label="$t('Please-least-3-digits')" append-icon="search">
        </v-text-field>


      </v-toolbar>
      <v-card-text>



        <!-- Begin Arama Kriterleri ******************************************************************************-->
        <!-- <div class="layout">
                <v-text-field v-model="prm.adSoyad" :label="$t('Name-Inquiry')" ></v-text-field>
                <btnprogres v-model="status.loading" title="Ara" @click="Ara()"></btnprogres>
            </div> -->
        <!-- End Arama Kriterleri  *******************************************************************************-->

        <!-- Begin Data Table ************************************************************************************-->
        <v-data-table  :headers="tableheaders" :items="tabledata" :loading="status.loading" hide-actions
          class="elevation-1">

          <template slot="items" slot-scope="props">
            <tr @click="Sec(props.item)">
              <td>{{ props.item.adSoyad }}</td>
              <td>{{ props.item.tcKimlikNo }}</td>
              <td>{{ props.item.gsm }}</td>
            </tr>
          </template>
        </v-data-table>
        <!-- End Data Table *************************************************************************************** -->
      </v-card-text>
    </v-card>
  </v-dialog>

</template>


<script>
  import tool from '../tools'
  import arksnackbar from '@/components/app/coper/comp/arksnackbar.vue'
  import btnprogres from '@/components/app/coper/comp/btnprogres.vue'
  import customdialog from "@/components/app/coper/comp/customdialog.vue";



  export default {
    components: {
      arksnackbar,
      btnprogres,
      customdialog,
    },

    props: ['value'],
    computed: {
      val: {
        get: function () {


          return this.value;
        },
        set: function (newValue) {

          this.$emit('input', newValue)
        },
      },
    },

    data() {
      return {
        prm: {},
        dialogShow: false,
        tableheaders: [{
            text: this.$t('Name_Surname_label'),
            value: 'adSoyad'
          },
          {
            text: this.$t('Identity-Number'),
            value: 'tcKimlikNo'
          },
          //  { text: 'eMail', value: 'eMail' },
          {
            text: 'Tel',
            value: 'gsm'
          },
        ],
        tabledata: [],
        status: tool.NewSatatus(),

      }
    },


    methods: {
      Ara: Ara,
      Sec: Sec,

    },
    watch: {
      'prm.adSoyad': function (val) {
        this.Ara();
      }
    }
  }


  function Sec(v) {

    if (v.dogumTarihi=="0001-01-01")
    {
      v.dogumTarihi=null
    }
    this.value.adres=v
     if (v.firstName=="" || v.firstName==null){
          this.value.adres.firstName=v.adSoyad
     }
    this.value.dialogShow = false;
  }


  function Ara() {
    this.tabledata = [];

    if (this.status.loading === false) {
      this.status.loading = true;
      setTimeout(() => {
        tool.http_post(this, 'TblAdresAra', this.prm).then((response) => {
          this.tabledata = response.body;
          this.status.loading = false;

        }, (response) => {
          this.status = tool.responseToStatus(response);
        })

      }, 500)
    }

  }
</script>